// project import
import dashboard from './dashboard';
import management from './management';
import support from './cadastros';
// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, management, support ]
};

export default menuItems;
